<template lang="html">
  <div class="row gallery" style="position: relative">
    <GalleryUpload @loaded="handleLoaded" />
    <template v-for="(img, index) in sortedImages">
      <GalleryImage
        @star="handleImageStarred"
        :key="'i-' + img.id"
        :starred="index === 0"
        :img="img"
        :deletable="!isEditing || isEditing && sortedImages.length > 1"/>
    </template>
    <template v-for="(img, index) in loadingImages">
      <GalleryImageLoading
        v-show="!img.isDone"
        :key="'u-' + index"
        :order="img.order"
        :file="img.file"
        @imageUploaded="handleImageUploaded"
        @errorInUpload="handleErrorInUpload"/>
    </template>
    <Loading :active="isUpdatingOrder" />
    <small v-if="uploadError" class="text-danger w-100 mx-3">
      Error al subir imágenes
    </small>
  </div>
</template>

<script>
import store from '@/store'
// components
import GalleryUpload from './GalleryUpload'
import GalleryImage from './GalleryImage'
import GalleryImageLoading from './GalleryImageLoading'

export default {
  components: {
    GalleryUpload,
    GalleryImage,
    GalleryImageLoading
  },

  props: {
    isEditing: Boolean
  },

  data: () => ({
    loadingImages: [],
    loadedImages: [],
    isUpdatingOrder: false,
    uploadError: false
  }),

  computed: {
    images: () => store.state.sell.images,

    nextOrder () {
      if (this.images.length === 0) return 0
      let lastOrderedImage = this.images.reduce((a,b) => Number(a.order) > Number(b.order) ? a : b)
      return lastOrderedImage.image_file_order
    },

    sortedImages () {
      return this.images.slice().sort((a, b) => {
        if (a.image_file_order > b.image_file_order) return 1
        if (b.image_file_order > a.image_file_order) return -1
        return 0
      })
    },
  },

  methods: {
    handleLoaded (files) {
      this.uploadError = false
      this.loadingImages = Array.from(files)
        .map(file => ({ file, order: this.nextOrder+1, isDone: false }))
    },

    handleImageUploaded (order) {
      this.loadingImages = this.loadingImages
        .map(i => i.order === order ? ({...i, isDone: true}) : i)
      if (this.loadingImages.every(i => i.isDone)) this.loadingImages = []
    },

    handleImageStarred (event) {
      let position = 2
      let promises = []
      for (let i = 0 ; i < this.sortedImages.length ; i++) {
        const image = this.sortedImages[i]
        if (image.id === event) {
          if (image.image_file_order !== 1) {
            promises = promises.concat(store.dispatch('sell/updateImageOrder', {id: image.id, order: 1}))
          }
        } else {
          if (image.image_file_order !== position) {
            promises = promises.concat(store.dispatch('sell/updateImageOrder', {id: image.id, order: position}))
          }
          position++
        }
      }
      this.isUpdatingOrder = true
      Promise.all(promises).then(() => {
        this.isUpdatingOrder = false
      })
    },

    handleErrorInUpload (fileName) {
      // Hides the loading element
      this.loadingImages.map(i => {
        i.isDone = true
        return i
      })
      // Random timeout to prevent inconsistencies caused by filtering an array concurrently - filter function makes
      // a copy of the original array every time
      setTimeout(() => {
        this.loadingImages = this.loadingImages.filter(i => i.file.name !== fileName)
      }, Math.random() * 1000)
      this.uploadError = true
    }
  }
}
</script>

<style lang="scss">
  @import '../../../scss/colors';
  @import '../../../scss/breakpoints';

  .gallery {
    /* display: flex; */
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/gallery/Gallery.vue